import { Box, Skeleton } from '@mui/material';

import { LAYOUT_MAX_WIDTH, PAGE_HORIZONTAL_PADDING } from '@/constants';

export const CategoryNavLinksSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      position: 'relative',
      bgcolor: 'background.default',
      borderBottom: '1px solid',
      borderColor: 'divider',
      width: '100%',
      px: PAGE_HORIZONTAL_PADDING,
    }}
  >
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { xs: 0, lg: 0.5 },
        width: '100%',
        maxWidth: LAYOUT_MAX_WIDTH,
        mx: 'auto',
        px: { xs: 0.5, sm: 1 },
        overflowX: 'auto',
        overflowY: 'visible',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      {[...Array(8)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={80}
          height={32}
          sx={{ borderRadius: 1, flexShrink: 0 }}
        />
      ))}
    </Box>
  </Box>
);
